const STEP_ROUTE_TYPE = 'STEP_ROUTE';
const END_PAGE_ROUTE_TYPE = 'END_PAGE_ROUTE';

const STEP_LIMITER = 'step--';
const END_PAGE_LIMITER = 'ep--';
const HASH = '#';

export {
  STEP_ROUTE_TYPE,
  END_PAGE_ROUTE_TYPE,
  STEP_LIMITER,
  END_PAGE_LIMITER,
  HASH,
};
